import React, { Component } from "react";
import networkList from "../../../../constants/networkList";
import postService from "../../../../services/httpService";
import { Modal, Spin, Tag } from "antd";
import userTrackService from "./../../../../services/usertrack-service";

const $ = require("jquery");

class User_Details extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadding: false,
      details: {},
      rid: null,
      thead: [],
      showAdd: true,
      showEdit: false,
      tbody: [],
      tableTitle: "",
      addText: "",
    };
  }
  editUser(data) {
    try {
      let { rid } = this.state;
      let { slug } = this.props.match.params;
      switch (slug) {
        case "view-user":
          this.props.history.push(`/settings/edit-user?rid=` + data["id"]);
          break;
        case "view-units":
          this.props.history.push(`/settings/view-units?rid=` + data["id"]);
          break;
        case "view-doctor":
          this.props.history.push(`/settings/edit-doctor?rid=` + data["id"]);
          break;
        case "view-work-stations":
          this.props.history.push(
            `/settings/edit-work-stations?rid=` + data["id"]
          );
          break;
        case "viewtvscreen":
          this.props.history.push(
            `/settings/edittvscreen?rid=` + data["tv_display_id"]
          );
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  }

  componentDidMount() {
    let { id, slug } = this.props.match.params;
    let { menuList } = this.props;
    menuList.map((menu) => {
      if (slug !== undefined && slug !== null && slug !== "") {
        if (menu["route"] === id) {
          menu["submenu"].map((smenu) => {
            if (smenu["route"] === slug) {
              if (smenu["permissions"]["view"]) {
                this.setState((state) => ({
                  showAdd: JSON.parse(smenu["permissions"]["add"]),
                  showEdit: JSON.parse(smenu["permissions"]["edit"]),
                }));
              } else {
              }
            }
          });
        }
      }
    });

    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    this.setState(
      (state) => ({ rid: rid, loadding: true }),
      () => {
        this.loadPage();
      }
    );
  }

  cancel() {
    const params = new URLSearchParams(this.props.location.search);
    const rid = params.get("rid");
    let { slug } = this.props.match.params;
    switch (slug) {
      case "view-user":
        this.props.history.push("/settings/users");
        break;
      case "view-doctor":
        this.props.history.push("/settings/doctors");
        break;
      case "view-work-stations":
        this.props.history.push("/settings/work-stations");
        break;
      case "viewtvscreen":
        this.props.history.push("/settings/tv-screens");
        break;
      case "view-units":
        this.props.history.push("/settings/units");
        break;

      default:
        break;
    }
  }

  loadPage = () => {
    try {
      let { rid } = this.state;
      let { slug } = this.props.match.params;
      const {
        getUserDetailsById,
        getDoctorIdDetails,
        getWorkStationDetails,
        getTvById,
      } = networkList;
      let tableHead = [];
      switch (slug) {
        case "view-user":
          tableHead = [
            {
              key: "username",
              text: "user Name",
            },
            {
              key: "rh_userid",
              text:"User ID",
            },
            {
              key: "rolename",
              text: "Role",
            },
            // {
            //   key: "access_name",
            //   text: "Access Level",
            // },
            {
              key: "unitids",
              text: "Unit",
            },
            {
              key: "work_station_name",
              text: "Work Station",
            }
          ];
          this.setState(
            (state) => ({
              addText: "User",
              tableTitle: "User View",
              thead: tableHead,
            }),
            () => {
              let Userlogobj = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "View User - Request",
                date: new Date(),
                meta: { id: rid },
              };

              userTrackService(Userlogobj);
              postService(getUserDetailsById, "POST", {
                data: { id: rid },
              }).then((res) => {
                let Userlogobjres = {
                  user: JSON.parse(localStorage.getItem("user")),
                  action: "View User - Response",
                  date: new Date(),
                  meta: res,
                };
                userTrackService(Userlogobjres);
                if (res.status) {
                  this.setState((state) => ({ loadding: false }));
                  this.setState((state) => ({
                    tbody: res.data[0],
                    loadding: false,
                  }));
                } else {
                  this.setState((state) => ({ loadding: false }));
                  Modal.error({
                    title: "Error message",
                    content: "Something went wrong. Please,try again later",
                    onOk: function () {
                      window.scrollTo(0, 0);
                    },
                  });
                }
              });
            }
          );
          break;
        case "view-doctor":
          tableHead = [
            {
              key: "name",
              text: "Doctor Name",
            },
            {
              key: "unitname",
              text: "Unit",
            },
            {
              key: "departmentname",
              text: "Department",
            },
            {
              key: "specialization_code",
              text: "Specialization",
            },
            {
              key: "experience",
              text: "Experience",
            },
            {
              key: "vitals_required",
              text: "Vitals",
            },

          ];
          this.setState(
            (state) => ({
              addText: "Doctor",
              tableTitle: "Doctor",
              thead: tableHead,
            }),
            () => {
              let Userlogobj = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "View User - Request",
                date: new Date(),
                meta: { id: rid },
              };
              userTrackService(Userlogobj);
              postService(getDoctorIdDetails, "POST", {
                data: { id: rid },
              }).then((res) => {
                let Userlogobjres = {
                  user: JSON.parse(localStorage.getItem("user")),
                  action: "View User - Response",
                  date: new Date(),
                  meta: res,
                };
                userTrackService(Userlogobjres);
                if (res.status) {
                  this.setState((state) => ({ loadding: false }));
                  this.setState((state) => ({
                    tbody: res.data[0],
                    loadding: false,
                  }));
                } else {
                  this.setState((state) => ({ loadding: false }));
                  Modal.error({
                    title: "Error message",
                    content: "Something went wrong. Please,try again later",
                    onOk: function () {
                      window.scrollTo(0, 0);
                    },
                  });
                }
              });
            }
          );
          break;
        case "view-work-stations":
          tableHead = [
            {
              key: "unitname",
              text: "Unit Name",
            },
            {
              key: "work_station_name",
              text: "Workstation Name",
            },
            {
              key: "cabin_count",
              text: "cabin count",
            },
            {
              key: "tv_url",
              text: "Tv Url",
            },
          ];
          this.setState(
            (state) => ({
              addText: "work station",
              tableTitle: "Work Station",
              thead: tableHead,
            }),
            () => {
              postService(getWorkStationDetails, "POST", {
                id: Number(rid),
              }).then((res) => {
           
                if (res.status) {
                  this.setState((state) => ({ loadding: false }));
                  this.setState((state) => ({
                    tbody: res.data[0],
                    loadding: false,
                  }));
                } else {
                  this.setState((state) => ({ loadding: false }));
                  Modal.error({
                    title: "Error message",
                    content: "Something went wrong. Please,try again later",
                    onOk: function () {
                      window.scrollTo(0, 0);
                    },
                  });
                }
              });
            }
          );
          break;
        case "viewtvscreen":
          tableHead = [
            {
              key: "display_name",
              text: "Display Name",
            },
            {
              key: "queue_list",
              text: "Queues",
            },
          ];
          this.setState(
            (state) => ({
              addText: "Tv Screen",
              tableTitle: "Tv Screen",
              thead: tableHead,
            }),
            () => {
              let Userlogobj = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "View User - Request",
                date: new Date(),
                meta: { id: rid },
              };
              userTrackService(Userlogobj);
              postService(getTvById, "POST", {
                data: { tv_display_id: rid },
              }).then((res) => {
                let Userlogobjres = {
                  user: JSON.parse(localStorage.getItem("user")),
                  action: "View User - Response",
                  date: new Date(),
                  meta: res,
                };
                userTrackService(Userlogobjres);
                if (res.status) {
                  this.setState((state) => ({ loadding: false }));
                  this.setState((state) => ({
                    tbody: res.data[0],
                    loadding: false,
                  }));
                } else {
                  this.setState((state) => ({ loadding: false }));
                  Modal.error({
                    title: "Error message",
                    content: "Something went wrong. Please,try again later",
                    onOk: function () {
                      window.scrollTo(0, 0);
                    },
                  });
                }
              });
            }
          );
          break;
        case "view-units":
          tableHead = [
            {
              key: "name",
              text: "Unit Name",
            },
            {
              key: "address",
              text: "Address",
            },
          ];
          this.setState(
            (state) => ({
              addText: "Unit",
              tableTitle: "Unit",
              thead: tableHead,
            }),
            () => {
              let Userlogobj = {
                user: JSON.parse(localStorage.getItem("user")),
                action: "View User - Request",
                date: new Date(),
                meta: { id: rid },
              };
              userTrackService(Userlogobj);
              return false;
              postService("", "POST", {
                data: { tv_display_id: rid },
              }).then((res) => {
                let Userlogobjres = {
                  user: JSON.parse(localStorage.getItem("user")),
                  action: "View User - Response",
                  date: new Date(),
                  meta: res,
                };
                userTrackService(Userlogobjres);
                if (res.status) {
                  this.setState((state) => ({ loadding: false }));
                  this.setState((state) => ({
                    tbody: res.data[0],
                    loadding: false,
                  }));
                } else {
                  this.setState((state) => ({ loadding: false }));
                  Modal.error({
                    title: "Error message",
                    content: "Something went wrong. Please,try again later",
                    onOk: function () {
                      window.scrollTo(0, 0);
                    },
                  });
                }
              });
            }
          );
          break;

        default:
          this.setState((state) => ({ loadding: false }));
          break;
      }
    } catch (error) {
      this.setState((state) => ({ loadding: false }));
      Modal.error({
        title: "Error message",
        content: "Something went wrong. Please,try again later",
        onOk: function () {
          window.scrollTo(0, 0);
        },
      });
  
    }
  };
  render() {
    let { thead, tbody, showEdit, tableTitle } = this.state;
    let { doctor_profile_url } = networkList;
    let { slug } = this.props.match.params;

    return (
      <Spin spinning={this.state.loadding}>
        <div className="card p-5 m-5">
          <div className="pb-5">
            <h1 className="text-heading float-left text-capitalize">
              {tableTitle}
            </h1>
            {/* {showEdit && (
              <a
                href="#"
                className="float-right"
                style={{ color: "#455a64" }}
                onClick={this.editUser.bind(this, tbody)}
              >
                Edit <img src="/assets/images/icons/edit.png" />
              </a>
            )} */}
          </div>
          <div className="row my-auto pb-3">
            {slug==='view-doctor'&&<div className="col-6">
            <img
          alt=""
          src={
            tbody && tbody.profile_pic
              ? doctor_profile_url + tbody.profile_pic
              : "/assets/images/newProfile.png"
          }
          className="qdoctorImg1"
        />
            </div>}
            {slug==='view-doctor'&&<div className="col-6">
              
             
            {console.log("tbody", tbody)}
            {thead.map((tHdata, tHkey) => {
              return (
                <div className="col-xl-12 col-lg-12 col-sm-6 d-flex" key={tHkey}>
                  <p className="data-label">{tHdata["text"]} </p>
                  <p className="data-item">
                    :{" "}
                    {tHdata["text"]==="Vitals"?tbody["vitals_required"]?"YES":"NO"
                  :
                    tbody[tHdata["key"]]
                      ? tHdata["key"] === "unitids"
                        ? tbody["unitids"].map((unit) => ` ${unit.unitname},  `)
                        : tHdata["key"] === "queue_list"
                        ? // ? tbody["queue_list"].map((ql) => ql.queue_list_name&& ql.queue_list_name)
                          tbody["queue_list"].map(
                            (ql) =>
                              ql.queue_list_name && `${ql.queue_list_name}, `
                          )
                        : tbody[tHdata["key"]]
                      : "--"}
                  </p>
                </div>
              );
            })}
            </div>}
            {console.log("tbody", tbody)}
            {slug!=='view-doctor'&& thead.map((tHdata, tHkey) => {
              return (
                <div className="col-xl-5 col-lg-5 col-sm-6 d-flex" key={tHkey}>
                  <p className="data-label">{tHdata["text"]} </p>
                  <p className="data-item">
                    :{" "}
                    {tbody[tHdata["key"]]
                      ? tHdata["key"] === "unitids"
                        ? tbody["unitids"].map((unit) => ` ${unit.unitname},  `)
                        : tHdata["key"] === "queue_list"
                        ? // ? tbody["queue_list"].map((ql) => ql.queue_list_name&& ql.queue_list_name)
                          tbody["queue_list"].map(
                            (ql) =>
                              ql.queue_list_name && `${ql.queue_list_name}, `
                          )
                        : tbody[tHdata["key"]]
                      : "--"}
                  </p>
                </div>
              );
            })}
          </div>
          <div className="row justify-content-center">
            <button
              className="btn btn-success btn-next text-capitalize"
              onClick={this.cancel.bind(this)}
            >
              Back
            </button>
          </div>
        </div>
      </Spin>
    );
  }
}
export default User_Details;
